import {
  COOKIE_PREFIX,
  COOKIE_REFRESH_TOKEN,
  COOKIE_ROLE,
  COOKIE_SESSION_ID,
  COOKIE_SESSION_TOKEN,
  cookieENV,
  isTest,
} from "constants/env-constants";
import { jwtDecode } from "jwt-decode";

import cookieStorage from ".";

type ROLES = "student" | "editor" | "teacher" | "admin";
interface AccessParams {
  jwt: string;
  role: ROLES;
  refreshToken: string;
}

interface DecodedToken {
  role: string;
}

/**
 *  Store cookies with information on currently connected user data.
 *
 * @param {object} jwt - Object with connected user data.
 * @param {ROLES} role - Name of the role for connected user.
 * @param {string} refreshToken - Refresh token value
 */
const setAccess = ({ jwt, role, refreshToken }: AccessParams): void => {
  const env = cookieENV();
  const prefixAndEnv = !isTest() ? `${COOKIE_PREFIX}${env}` : `${env}`;
  cookieStorage.setItem(`${prefixAndEnv}-${COOKIE_ROLE}`, role);
  cookieStorage.setItem(`${prefixAndEnv}-${COOKIE_SESSION_TOKEN}`, jwt);
  cookieStorage.setItem(`${prefixAndEnv}-${COOKIE_REFRESH_TOKEN}`, refreshToken);
};

/**
 *  Clear current user session data from cookies.
 */
const clearCookiesLogout = (): void => {
  const env = cookieENV();
  const prefixAndEnv = !isTest() ? `${COOKIE_PREFIX}${env}` : `${env}`;
  cookieStorage.removeItem(`${prefixAndEnv}-${COOKIE_ROLE}`);
  cookieStorage.removeItem(`${prefixAndEnv}-${COOKIE_SESSION_ID}`);
  cookieStorage.removeItem(`${prefixAndEnv}-${COOKIE_SESSION_TOKEN}`);
  cookieStorage.removeItem(`${prefixAndEnv}-${COOKIE_REFRESH_TOKEN}`);
};

/**
 *  Get role user from token.
 */
const getAccountRole = (): string | unknown => {
  try {
    const token = cookieStorage.getToken();
    const decodedToken = jwtDecode<DecodedToken>(token);
    return decodedToken.role;
  } catch (error) {
    return error;
  }
};

export { setAccess, clearCookiesLogout, getAccountRole };
